import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as SVG } from '../svgs/beast.svg';

const BeastIcon = React.memo(({ background, size, style }) => (
  <div
    style={{
      background,
      borderRadius: '50%',
      color: '#FFFFFF',
      fontSize: 21,
      height: size,
      left: '-50%',
      lineHeight: '1.6em',
      marginLeft: -10,
      marginTop: -10,
      position: 'absolute',
      textAlign: 'center',
      top: '-50%',
      verticalAlign: 'middle',
      width: size,
      ...style,
    }}>
    <SVG />
  </div>
));

BeastIcon.defaultProps = {
  background: '#000000',
  size: 28,
  style: {},
};

BeastIcon.propTypes = {
  background: PropTypes.string,

  size: PropTypes.number,
  style: PropTypes.shape(),
};

export default BeastIcon;
